<template>

    <modal @close="$emit('close')">
        <p class="text-white font-bold text-xl mt-2" slot="header">Оплатить участие</p>
        <div class="py-8">
            <div class="flex flex-col text-center w-full justify-center items-center pt-4">
                <img class="-mt-6 flex w-2/5 mb-6" src="@/assets/big-cross.png" alt="check-circle">
                <h3 class="flex flex-col text-center w-full justify-center items-center text-xl">
                    Извините,<br>
                    места кончились!</h3>
                <p class="font-semibold text-sm flex justify-center text-center mt-1">Вы можете записаться в резерв.</p>
            </div>
            <button @click="$emit('close')"
                    class="flex justify-center items-center mx-auto bg-brand-light rounded-full text-white text-xl font-semibold w-2/3 h-10 mt-5">
                Резерв
            </button>
        </div>
    </modal>

</template>

<script>
import ModalMixin from '../../../mixins/modals.js';
import Modal from '@/views/modals/base-modal';

export default {
  name: 'Error',
  components: { Modal },
  props: ['error'],
  mixins: [ModalMixin],
  data() {
    return {
      ext: '',
      show: false,
      loaded: false,
    };
  },

};

</script>

<style scoped>

</style>
